<!-- Outbound popup here -->
<app-customer-account-dialog class="hide bad-address-overlay">
  <div id="content">
    <div class="alert-header">
      <h3 class="custom-model-heading">Bad Address Indicator</h3>
      <!-- Close  button should be enabled on conditional basis -->
      <div class="close-btn hide">
        <button mat-icon-button mat-dialog-close >
          <f-icon icon-config='{"iconName": "xmark", "iconType": "solid", "iconSize": "s"}'></f-icon>
        </button>
      </div>
    </div>
    <p>This customer has a Bad Address Indicator and cannot proceed with PIN creation.</p>
    <p class="margin-top-gap">Use the One-time Code option to authenticate the customer. Then, assist them in correcting their address and/or removing the Bad Address Indicator.</p>
    <div class="custom-overlay-footer">
      <f-button text="Got it" mat-dialog-close tabindex="1" buttonTitle="Got it" type="button" variant="progressive"
      >
      </f-button>
    </div>
  </div>
</app-customer-account-dialog>
<f-data-card>
  <div class="container authentication pos-relative">
    <app-otc-phone-flow class="otc-flow" *ngIf="otcService.openCountryCodeDialog && rootScope.activeCustTab.activeCall"></app-otc-phone-flow>
    <div class="row authentication-top">
      <div class="col-md-12 col-lg-6 authentication-left">
        <h5>Authentication</h5>
         <f-alert variant="success" *ngIf="isCallDeSecuredFromIndicativeData()" class="status-msg">
          Success! You have successfully changed this call to Unsecured.
        </f-alert> 
        <div class="error-wrapper" *ngIf="cusAccService.authSucessMsg()">
          <f-alert variant="success">{{validationSuccessMessage}}</f-alert>
        </div>
        <!-- Success msg for Biometrics starts -->
        <div class="error-wrapper " *ngIf="rootScope.activeCustTab.biometricData.biometricCompleted && rootScope.activeCustTab.CS_SECURITY_LEVEL === securityLevel.SL4">
          <f-alert variant="success">Success! This customer is fully secured for this line of business.</f-alert>
        </div>
        <!-- Success msg for Biometrics ends -->
        <div class="error-wrapper"
          *ngIf="rootScope.isLiveCall&&rootScope.activeCustTab && rootScope.activeCustTab.CS_SECURITY_LEVEL===securityLevel.SL4  && rootScope.activeCustTab?.pinEntryApp?.pinValidMsg && !rootScope.activeCustTab?.genesysAttributes?.CP_INDICATIVE_DATA_SECURED">
          <f-alert variant="success">{{pinEntrySuccessMessage}}</f-alert>
        </div>
        <div class="error-wrapper"
          *ngIf="rootScope.isLiveCall&&rootScope.activeCustTab.CS_SECURITY_LEVEL===securityLevel.SL4 && rootScope.activeCustTab?.otcData?.validateOtcSuccess">
          <f-alert variant="success">{{otcValidateSuccessMessage}}</f-alert>
        </div>
        <div class="error-wrapper" *ngIf="cusAccService.clearSuccessMsg()">
          <f-alert variant="success">{{rootScope.activeCustTab.isEIVSelected ? EIV_MSG : clearVerificationSuccessMessage}}</f-alert>
        </div>
        <div class="error-wrapper" *ngIf="rootScope.authConfigUserDataMap?.[this.rootScope.activeCustTab.customerSessionId]?.preAuthUserAPIFail && !cusAccService.authSucessMsg() && !isAuthenticationMethodVisible(eGainConfig.PIN_FSBA)">
          <f-alert variant="error">{{API_FAil_MSG}}
            <button (click)="getPreAuthUserData()" class="btn-alert">Try again</button></f-alert>
        </div>
        <!--PersonStatus = NOF and userID is blank-->
        <div class="error-wrapper" *ngIf="invalidCustomer()">
          <f-alert variant="error">{{userDataBlankMsg}}</f-alert>
        </div>
        <div class="error-wrapper" >
        <f-alert variant="error"
        class="status-msg"  *ngIf="rootScope.activeCustTab.pinEntryApp.success ==='false' && !cusAccService.authSucessMsg() && !isAuthenticationMethodVisible(eGainConfig.PIN_FSBA) && !rootScope.activeCustTab?.otcData?.validateOtcSuccess" >
        The PIN entry was unsuccessful. Choose an available authentication method to continue.
      </f-alert>
      <f-alert variant="error"
        class="status-msg"  *ngIf="rootScope.activeCustTab.pinEntryApp.success ==='false' && !cusAccService.authSucessMsg() && isAuthenticationMethodVisible(eGainConfig.PIN_FSBA) && !rootScope.activeCustTab?.otcData?.validateOtcSuccess" >
        The PIN entry was unsuccessful.
      </f-alert>
    </div>
        <div class="error-wrapper hide">
          <f-alert variant="info"> Some customer data may be unavailable until the call is fully authenticated.
          </f-alert>
        </div>
        <div class="card-row">
          <div class="card-left">
            <h6>Authentication Status</h6>
          </div>
          <div class="card-right">
            <p class="auth-status">
              <span [ngClass]="
                  cusAccService.identifyAuthenticateClass(
                    rootScope.activeCustTab.authenticateStatus
                  )
                "></span>
              {{ rootScope.activeCustTab.authenticateStatus }}
            </p>
            <!-- Added "rootScope.activeCustTab?.channel == channel.call" codition to show only call scenario for US CCR3-6018 -->
              <p *ngIf="rootScope.activeCustTab?.genesysAttributes?.CS_AUTH_CD && rootScope.activeCustTab?.channel === channel.call && rootScope.activeCustTab.CS_SECURITY_LEVEL==='4' "
              class="font-normal auth-method"> {{getMethodName()}} </p>
          </div>
        </div>
        <f-alert variant="success" class="status-msg hide">Customer authentication is complete. Your call is now fully
          secured.</f-alert>
        <f-alert variant="info"
          *ngIf="this.rootScope.isLiveCall && !rootScope.customerTypeAPIFailure && !rootScope.activeCustTab.authenticationContents.authenticationConfigMiss && this.rootScope.activeCustTab?.CS_SECURITY_LEVEL !== '4' && rootScope.activeCustTab.pinEntryApp.success !=='false'"
          class="status-msg hide1">Some customer data
          may be unavailable until the call is fully
          authenticated.</f-alert>

        <f-alert variant="error"
          *ngIf="rootScope.activeCustTab.authenticationContents.authenticationConfigMiss && rootScope.activeCustTab.pinEntryApp.success !=='false'"
          class="status-msg">
          {{infoCodes.AUTHCNF001}}
        </f-alert>
        <f-alert variant="error"
          *ngIf="rootScope.activeCustTab.IS_AAAS_ENABLED && !aaaSservice.AaaSFieldListData?.[rootScope.activeCustTab.clientId]"
          class="status-msg">
          {{infoCodes.AAASCCF001}}
        </f-alert>
       
        <f-alert variant="error" *ngIf="aaasErrorMsg()" class="status-msg">
          {{rootScope.accountAaaSConfig.AAASUserAPIFail?infoCodes.AAASCCF003 :infoCodes.AAASCCF002}}
          <button *ngIf="rootScope.accountAaaSConfig.AAASUserAPIFail" (click)="aaaSservice.getAaasUserAuthMethod()"
            class="btn-alert">Try again</button>
        </f-alert>

        <section *ngIf="rootScope.activeCustTab.authenticationContents.authenticationAPIfailure" class="error-wrapper">
          <f-alert variant="error">
            {{errorMsg}}
            <button (click)="tryAgainAuthenticationAPI()" class="btn-alert">Try again</button>
          </f-alert>
        </section>

        <section *ngIf="rootScope.customerTypeAPIFailure" class="error-wrapper">
          <f-alert variant="error">
            {{errorMsg}}
            <button (click)="apiService.getCustomerTypesAPI()" class="btn-alert">Try again</button>
          </f-alert>
        </section>
        
        <div *ngIf="deSecureCallFeatureEnable()"  class="desecure-call">
          <f-button text="Click here"  [disabled]="rootScope.activeCustTab.isGenesysUnsecureSecurityLevelUpdateProcessing" (click)="desecureAccount()" variant="action">
          </f-button>
           if you want to Desecure the call.
        </div>

        <div class="card-row">
          <div class="card-left">
            <p class="customer-type">Who is it?</p>
             
            <!--label (Caller/Customer Type) name change for CCR1-5039-->
            <app-alight-drop-down [group]="rootScope.customerTypeForm" [controlName]="'customerType'" [required]="false"
              description="fieldValueDescription" [disable]="cusAccService.callerTypeValidation()"
              label="Caller/Customer Type" [value]="'fieldValue'" [list]="rootScope.customerTypeData"
              (changeEvent)="changeCustomerType($event)">
            </app-alight-drop-down>
          </div>
         
        </div>
        <div class="card-row attempt-details hide1" *ngIf="!rootScope.activeCustTab?.IS_AAAS_ENABLED">
          <div *ngIf="rootScope.accountSAuthConfig?.remainingPswdAttempt">
            <p class="attempt-label">Available attempts</p>
            <p class="attempt-count">
              {{ rootScope.accountSAuthConfig?.remainingPswdAttempt}}
            </p>
          </div>
          <div class="show" *ngIf="rootScope.accountSAuthConfig?.voicePinResetDate">
            <p class="attempt-label ">Last Phone PIN Reset</p>
            <p class="attempt-value">{{ rootScope.accountSAuthConfig?.voicePinResetDate?.substring(0,23) | date:'MMM-dd-yyyy HH:mm:ss' }}</p>
          </div>
          <div class="show" *ngIf="rootScope.accountSAuthConfig?.pswdResetDate">
            <p class="attempt-label">Last Password Reset</p>
            <p class="attempt-value">{{ rootScope.accountSAuthConfig?.pswdResetDate?.substring(0,23) | date:'MMM-dd-yyyy HH:mm:ss' }}</p>
          </div>
        
        </div>

        <div class="card-row attempt-details hide1" *ngIf="rootScope.activeCustTab?.IS_AAAS_ENABLED">
         
          <div class="show" *ngIf="rootScope.accountAaaSConfig?.voicePinResetDate">
            <p class="attempt-label ">Last Phone PIN Reset</p>
            <p class="attempt-value">{{ rootScope.accountAaaSConfig?.voicePinResetDate?.substring(0,23) | date:'MMM-dd-yyyy HH:mm:ss' }}</p>
          </div>
          <div class="show" *ngIf="rootScope.accountAaaSConfig?.pswdResetDate">
            <p class="attempt-label">Last Password Reset</p>
            <p class="attempt-value">{{ rootScope.accountAaaSConfig?.pswdResetDate?.substring(0,23) | date:'MMM-dd-yyyy HH:mm:ss' }}</p>
          </div>
        
        </div>

      </div>
      <div class="col-md-12 col-lg-6 authentication-right">
 <!--Refresh icon on Egain Panel, to be shown on condition basis-->
 <div class="refresh-egain hide1">
  <button mat-button color="primary" title="Refresh" class="btn-refresh" (click)="getAuthenticationConfig()">
    <f-icon class="blue" icon-config='{"iconName": "arrows-rotate", "iconType": "solid", "iconSize": "s"}'></f-icon>
  </button>
 </div>
 <div class="authentication-content">
  
        <div class="flex justify-space-between">
          <h1>{{rootScope.activeCustTab?.authenticationEgainContent?.overViewHtml?.name}}</h1>
          <button mat-button color="primary" class="show-hide" id="toggle-1" (click)="showContent = !showContent">
            {{ showContent ? "Show Less" : "Show More" }}
            <span *ngIf="!showContent"><f-icon icon-config='{"iconName": "angle-down", "iconType": "light", "iconSize": "s"}'></f-icon></span>
            <span *ngIf="showContent"><f-icon icon-config='{"iconName": "angle-up", "iconType": "light", "iconSize": "s"}'></f-icon></span>
          </button>
        </div>
        <div class="show-hide-data" *ngIf="showContent">
          <section *ngIf="rootScope.activeCustTab?.authenticationEgainContent?.overViewError">
            <f-alert variant="error" class="status-msg hide1">
              {{rootScope.activeCustTab?.authenticationEgainContent?.overViewError}} </f-alert>
          </section>

          <div 
            [innerHTML]="rootScope.activeCustTab?.authenticationEgainContent?.overViewHtml?.content| safe: 'html'">
          </div>
            <!-- Functional Loader to be added when in use -->
        <app-loader *ngIf="showLoader" [loaderType]="loaderType"></app-loader>
        </div>
        </div>
      </div>
    </div>

    <div class="row col-rev authentication-bottom">
      <div class="col-md-12 col-lg-6 authentication-left">
        <mat-accordion class="authentication-method">
            <!-- Biometrics -->
        
          <mat-expansion-panel *ngIf="isAuthenticationMethodVisible(eGainConfig.MB) && 
          rootScope.accountSAuthConfig.MB" 
          (opened)="openAccState(eGainConfig.MB)" (closed)="closeAccState(eGainConfig.MB)"  [expanded]='menuExpansionType(eGainConfig.MB)' >
            <mat-expansion-panel-header>
               <mat-panel-title>
                <ng-container *ngIf="enableAuthLink(eGainConfig.MB); else elseBlock10">
                 Biometrics
                </ng-container>
                <ng-template #elseBlock10 >
                  <span class="disabledLink"> Biometrics (Unavailable)</span>
                </ng-template>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <app-biometrics *ngIf="enableAuthLink(eGainConfig.MB)"> </app-biometrics>
            <div *ngIf="infoValidation(eGainConfig.MB)" class="error-wrapper">
              <f-alert variant="info" class="status-msg">{{infoMessage}}</f-alert>
            </div>
            <!-- CCR3-16385 Display Refresh Option for Biometric Registration Status -->
             <div class="error-wrapper hide">
              <f-alert variant="error" class="status-msg">Unable to refresh biometric eligibility. Try again or proceed with an alternative authentication method.</f-alert>
            </div>
             <div class="hide">  <strong>Note: </strong> The caller can register for biometric authentication in the Alight Mobile App during this call. Once registration is complete,  click  <button class="btn-alert">Refresh</button> to check eligibility again. </div>
          </mat-expansion-panel>
          
          <!-- First Time User -->
          <mat-expansion-panel (opened)="openAccState(eGainConfig.FTU)" (closed)="closeAccState(eGainConfig.FTU)"
            [expanded]='menuExpansionType(eGainConfig.FTU)' *ngIf="isPeaVisible(eGainConfig.FTU)&&(rootScope?.accountSAuthConfig?.FTU||rootScope.accountAaaSConfig?.FTU)">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <ng-container *ngIf="enableAuthLink(eGainConfig.FTU); else elseBlock1">
                  First-time User
                </ng-container>
                <ng-template #elseBlock1 >
                  <span class="disabledLink"> First-time User (Unavailable)</span>                    
                </ng-template>
              </mat-panel-title>
             
            </mat-expansion-panel-header>
            <div *ngIf="infoWarning(eGainConfig.FTU)" class="error-wrapper">
              <f-alert variant="info" class="status-msg">{{infoMessage}}</f-alert>
            </div>
            <!----Bad Address Info message-->
            <div class="error-wrapper hide">
              <f-alert variant="info" class="status-msg">This customer has a Bad Address Indicator and needs to proceed with One-time Code</f-alert>
            </div>

           <app-ftu-panel *ngIf="enableAuthLink(eGainConfig.FTU)" [languages]="languages" ></app-ftu-panel>
          
          </mat-expansion-panel>
          <!-- FTU close here -->
          
          <!-- One Time Code -->
          <mat-expansion-panel (opened)="openAccState(eGainConfig.OTC)" (closed)="closeAccState(eGainConfig.OTC)"
            [expanded]='menuExpansionType(eGainConfig.OTC)' *ngIf="isAuthenticationMethodVisible('OTC')">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <ng-container *ngIf="enableAuthLink('OTC'); else elseBlock2">
                  <span  [ngClass]="getOTCMsgAndState() ? 'disabledLink' : ''">One-Time Code <span *ngIf="getOTCMsgAndState()">(Unavailable)</span></span>
                </ng-container>
                <ng-template #elseBlock2 >
                  <span class="disabledLink"> One-Time Code (Unavailable)</span>                    
                </ng-template>
              </mat-panel-title> 
            </mat-expansion-panel-header>
            <div class="main-otc" *ngIf="enableAuthLink('OTC')">

              <f-alert variant="info" [ngClass]="displayOTCMsg ? 'hide1' : 'hide'"> {{ OTCMsg }}</f-alert>

              <f-alert variant="success" class="status-msg hide"> Success! Click on Customer Overview to exit the
                Authentication page and proceed with the call.</f-alert>
                
              <app-one-time-code *ngIf="!displayOTCMsg"></app-one-time-code>
            </div>
            <div *ngIf="infoValidation('OTC')" class="error-wrapper">
              <f-alert variant="info" class="status-msg">{{infoMessage}}</f-alert>
            </div>
          </mat-expansion-panel>

          
          <!-- PIN Entry -->
          <mat-expansion-panel  (opened)="openAccState(eGainConfig.PIN)" (closed)="closeAccState(eGainConfig.PIN)"
            [expanded]='menuExpansionType(eGainConfig.PIN)' *ngIf="isPeaVisible(eGainConfig.PIN)">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <ng-container *ngIf="(!peaDisabled && enableAuthLink('PIN')); else elseBlock7">
                  <span>PIN Entry </span>
                </ng-container>
                <ng-template #elseBlock7>
                  <span class="disabledLink"> PIN Entry (Unavailable)</span>
                </ng-template>
              
              </mat-panel-title>
            </mat-expansion-panel-header>

            <section [ngClass]="peaDisabled ? 'hide1' : 'hide'" class="error-wrapper">
              <f-alert variant="info"  [ngClass]="peaDisabled ? 'hide1' : 'hide'">
                {{getMsg(eGainConfig.PIN)}}                
               </f-alert>
            </section> 

            <div class="pin-container" *ngIf="enableAuthLink('PIN')&& !peaDisabled">
             
              <div class="step-container flex justify-space-between">
                <!-- step-1 -->
                <span class="step-val "  [ngClass]="{ 'active' :rootScope.activeCustTab.pinEntryApp?.step1Active || rootScope.activeCustTab.pinEntryApp?.step1Complete }">
                  <span class="step-circle "
                    [ngClass]="rootScope.activeCustTab.pinEntryApp?.step1Active? 'active' : 'complete'">
                    <span *ngIf="rootScope.activeCustTab.pinEntryApp?.step1Complete"> <f-icon
                        icon-config='{"iconName": "check", "iconType": "solid", "iconSize": "s"}'></f-icon></span>
                    <span class="step-no" *ngIf="rootScope.activeCustTab.pinEntryApp?.step1Active">1</span>
                  </span>Go to ALIS</span>
                <!-- step-2 -->
                <span class="step-val" [ngClass]="{ 'active' :rootScope.activeCustTab.pinEntryApp?.step2Active || rootScope.activeCustTab.pinEntryApp?.step2Complete }">
                  <span class="step-circle"
                    [ngClass]="{ 'active' :rootScope.activeCustTab.pinEntryApp?.step2Active,'complete': rootScope.activeCustTab.pinEntryApp?.step2Complete }">
                    <span *ngIf="rootScope.activeCustTab.pinEntryApp?.step2Complete"> <f-icon
                        icon-config='{"iconName": "check", "iconType": "solid", "iconSize": "s"}'></f-icon></span>
                    <span class="step-no" *ngIf="!rootScope.activeCustTab.pinEntryApp?.step2Complete">2</span>
                  </span>Transfer the call</span>
                <!-- step-3 -->
                <span class="step-val" [ngClass]="{ 'active' :rootScope.activeCustTab.pinEntryApp?.step3Active || rootScope.activeCustTab.pinEntryApp?.step3Complete }">
                  <span class="step-circle"
                    [ngClass]="{ 'active' :rootScope.activeCustTab.pinEntryApp?.step3Active,'complete': rootScope.activeCustTab.pinEntryApp?.step3Complete }">
                    <span *ngIf="rootScope.activeCustTab.pinEntryApp?.step3Complete"> <f-icon
                        icon-config='{"iconName": "check", "iconType": "solid", "iconSize": "s"}'></f-icon></span>
                    <span class="step-no" *ngIf="!rootScope.activeCustTab.pinEntryApp?.step3Complete">3</span>
                  </span>Resume conversation</span>
              </div>
              <!-- For step-1 content  -- Pin Entry without language selection -->
              <p class="steps-content step1-content"
                *ngIf="rootScope.activeCustTab.pinEntryApp?.step1Active && !(languages?.length > 1)">
                Go to ALIS to transfer the customer to the PIN Entry App.
              </p>
              <!-- For step-1 content -- Pin Entry with language selection -->
              <p class="steps-content step1-content"
                *ngIf="rootScope.activeCustTab.pinEntryApp?.step1Active && languages?.length > 1">
                Select the language for the PIN Entry App. Then, press the PIN Entry button and go to ALIS to transfer the customer to PIN Entry App.
              </p>
              <mat-radio-group *ngIf="languages?.length > 1 && rootScope.activeCustTab.pinEntryApp?.step1Active"
                color="primary" class="account-selection" disableRipple aria-label="Select an option"
                [(ngModel)]="selectedLanguage" (change)="onRadioChange($event.value)">
                <mat-radio-button class="delivery-method-button" *ngFor="let language of languages"
                  [value]="language.code">
                  {{language.label}}
                </mat-radio-button>
              </mat-radio-group>

              <!-- For step-2 content -->
              <p class="pin-content step2-content hide1" *ngIf="rootScope.activeCustTab.pinEntryApp?.step2Active">
                The customer will be transferred to ALIS and enter their PIN.
              </p>
              <!-- For step-3 content -->
              <p class="pin-content step3-content hide1" *ngIf="rootScope.activeCustTab.pinEntryApp?.step3Active">
                After the transfer is complete, the customer will return to the Care Portal.
              </p>
              <div class="btn-refresh-container flex">
                <div class="btn-controls">
                  <f-button text="PIN Entry" title="PIN Entry" [disabled]="!rootScope.isLiveCall && rootScope.activeCustTab.CS_SECURITY_LEVEL==='4'"
                    *ngIf="rootScope.activeCustTab.pinEntryApp?.step1Active" type="button"
                    (buttonClicked)="pinEntryAttrUpdate()" variant="progressive" class=""></f-button>
                  <f-button text="Cancel" title="Cancel" (buttonClicked)="cancelButton()"
                    *ngIf="rootScope.activeCustTab.pinEntryApp?.step2Active"
                    [disabled]="rootScope.activeCustTab.pinEntryApp?.step3Active" type="button" variant="action"
                    class="hide1"></f-button>
                </div>
                <!-- Enable to show refresh message  -->
                <div class="refresh-link " *ngIf="rootScope.activeCustTab.pinEntryApp?.step3Active">
                  <p> If the Security Level didn’t update as expected, click <button class="btn-alert"  (click)="genesysCloudService.getLiveCallStatusForAuthMethod()" [ngClass]="{'disabledLink': rootScope.simulationData?.isSimulationModeActive}">Refresh</button></p>
                </div>
              </div>
              
            </div>

           

          </mat-expansion-panel>

           <!-- PIN Entry for FSBA Client -->
          <mat-expansion-panel (opened)="openAccState(eGainConfig.PIN_FSBA)" (closed)="closeAccState(eGainConfig.PIN_FSBA)"
            [expanded]='menuExpansionType(eGainConfig.PIN_FSBA)' *ngIf="isAuthenticationMethodVisible(eGainConfig.PIN_FSBA)">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <ng-container *ngIf="enableAuthLink(eGainConfig.PIN_FSBA); else elseBlock2">
                  <span>PIN Entry </span>
                </ng-container>
                <ng-template #elseBlock2 >
                  <span class="disabledLink"> PIN Entry (Unavailable)</span>                    
                </ng-template>
              </mat-panel-title> 
            </mat-expansion-panel-header>
            <div class="main-otc" *ngIf="enableAuthLink(eGainConfig.PIN_FSBA)">
                
              <app-pin-entry-fsbs [languages]="languages"></app-pin-entry-fsbs>
            </div>
            <div *ngIf="infoValidation(eGainConfig.PIN_FSBA)" class="error-wrapper">
              <f-alert variant="info" class="status-msg">{{infoMessage}}</f-alert>
            </div>
          </mat-expansion-panel>

           <!-- PIN Reminder -->
          <mat-expansion-panel (opened)="openAccState(eGainConfig.PIN_REM_FSBA)" (closed)="closeAccState(eGainConfig.PIN_REM_FSBA)"
            [expanded]='menuExpansionType(eGainConfig.PIN_REM_FSBA)' *ngIf="isAuthenticationMethodVisible(eGainConfig.PIN_REM_FSBA)">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <ng-container *ngIf="enableAuthLink(eGainConfig.PIN_REM_FSBA); else elseBlock2">
                  <span  >PIN Reminder </span>
                </ng-container>
                <ng-template #elseBlock2 >
                  <span class="disabledLink"> PIN Reminder (Unavailable)</span>                    
                </ng-template>
              </mat-panel-title> 
            </mat-expansion-panel-header>
            <div class="main-otc" *ngIf="enableAuthLink(eGainConfig.PIN_REM_FSBA)">         
              <app-pin-reminder ></app-pin-reminder>
            </div>
            <div *ngIf="infoValidation(eGainConfig.PIN_REM_FSBA)" class="error-wrapper">
              <f-alert variant="info" class="status-msg">{{infoMessage}}</f-alert>
            </div>
          </mat-expansion-panel>

              <!-- PIN Change -->
              <mat-expansion-panel  (opened)="openAccState(eGainConfig.PINCNG)"
                (closed)="closeAccState(eGainConfig.PINCNG)" [expanded]='menuExpansionType(eGainConfig.PINCNG)' *ngIf="isPeaVisible(eGainConfig.PINCNG)">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <ng-container *ngIf="(enableAuthLink('PINCNG')&&pinChangeEnabled); else elseBlock">
                      PIN Change
                    </ng-container>
                    <ng-template #elseBlock >
                      <span class="disabledLink">  PIN Change (Unavailable)</span>                    
                    </ng-template>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <f-alert variant="info"  [ngClass]="!pinChangeEnabled  ? 'hide1' : 'hide'">
                  {{pinChangeErrorHandler()}}                
                 </f-alert>
                  <!----Bad Address Info message-->
            <div class="error-wrapper hide">
              <f-alert variant="info" class="status-msg">This customer has a Bad Address Indicator and needs to proceed with One-time Code</f-alert>
            </div>
                <div class="pin-container" *ngIf="pinChangeEnabled">
                  <div class="step-container flex justify-space-between">
                    <!-- step-1 -->
                    <span class="step-val ">
                      <span class="step-circle " [ngClass]="rootScope.activeCustTab.pinChangeApp?.step1Active? 'active' : 'complete'">
                        <span *ngIf="rootScope.activeCustTab.pinChangeApp?.step1Complete"> <f-icon icon-config='{"iconName": "check", "iconType": "solid", "iconSize": "s"}'></f-icon></span>
                        <span class="step-no" *ngIf="rootScope.activeCustTab.pinChangeApp?.step1Active">1</span>
                      </span>Go to ALIS</span>
                    <!-- step-2 -->
                    <span class="step-val">
                      <span class="step-circle"
                        [ngClass]="{ 'active' :rootScope.activeCustTab.pinChangeApp?.step2Active,'complete': rootScope.activeCustTab.pinChangeApp?.step2Complete }">
                        <span *ngIf="rootScope.activeCustTab.pinChangeApp?.step2Complete"> <f-icon icon-config='{"iconName": "check", "iconType": "solid", "iconSize": "s"}'></f-icon></span>
                        <span class="step-no" *ngIf="!rootScope.activeCustTab.pinChangeApp?.step2Complete">2</span>
                      </span>Transfer the call</span>
                    <!-- step-3 -->
                    <span class="step-val">
                      <span class="step-circle"
                        [ngClass]="{ 'active' :rootScope.activeCustTab.pinChangeApp?.step3Active,'complete': rootScope.activeCustTab.pinChangeApp?.step3Complete,'failure': rootScope.activeCustTab.pinChangeApp?.step3Failed }">
                        <span
                          *ngIf="rootScope.activeCustTab.pinChangeApp?.step3Complete || rootScope.activeCustTab.pinChangeApp?.step3Failed">
                          <f-icon [iconConfig]="{iconName: rootScope.activeCustTab.pinChangeApp?.step3Complete ? 'check' : 'xmark', iconType: 'solid', iconSize: 's'}"></f-icon></span>
                        <span class="step-no"
                          *ngIf="!rootScope.activeCustTab.pinChangeApp?.step3Complete && !rootScope.activeCustTab.pinChangeApp?.step3Failed">3</span>
                      </span>Resume conversation</span>
                  </div>
                  <!-- For step-1 content  -- Pin change without language selection -->
                  <p class="steps-content step1-content"
                    *ngIf="rootScope.activeCustTab.pinChangeApp?.step1Active && !(languages?.length > 1)">
                    Go to ALIS to transfer the customer to the PIN Entry App.
                  </p>
                  <!-- For step-1 content -- Pin change with language selection -->
                  <p class="steps-content step1-content"
                    *ngIf="rootScope.activeCustTab.pinChangeApp?.step1Active && languages?.length > 1">
                    Select the language for the PIN Entry App. Then, press the PIN Change button and go to ALIS to transfer the customer to PIN Entry App.
                  </p>
                  <mat-radio-group *ngIf="languages?.length > 1 && rootScope.activeCustTab.pinChangeApp?.step1Active" color="primary"
                    class="account-selection" disableRipple aria-label="Select an option" [(ngModel)]="selectedLanguage"
                    (change)="onRadioChange($event.value)">
                    <mat-radio-button class="delivery-method-button" *ngFor="let language of languages" [value]="language.code">
                      {{language.label}}
                    </mat-radio-button>
                  </mat-radio-group>
              
                  <!-- For step-2 content -->
                  <p class="pin-content step2-content hide1" *ngIf="rootScope.activeCustTab.pinChangeApp?.step2Active">
                    The customer will be transferred to ALIS and follow prompts to change their PIN.
                  </p>
                  <!-- For step-3 content -->
                  <p class="pin-content step3-content hide1"
                    *ngIf="rootScope.activeCustTab.pinChangeApp?.step3Active && !rootScope.activeCustTab.pinChangeApp?.pinChangeSucess">
                    After the PIN change, the customer will return to the Care Portal.
                  </p>
                  <section
                    *ngIf="this.rootScope.activeCustTab.pinChangeApp.step3Complete && rootScope.activeCustTab.pinChangeApp?.pinChangeSucess"
                    class="error-wrapper">
                    <f-alert variant="success">
                      PIN Change was successful.
                    </f-alert>
                  </section>
                  <section
                    *ngIf="this.rootScope.activeCustTab.pinChangeApp.step3Failed && !rootScope.activeCustTab.pinChangeApp?.pinChangeSucess && rootScope.activeCustTab.pinChangeApp?.pinChngError"
                    class="error-wrapper">
                    <!--CCR3-11548 Replace hardcoded message with dynamic PIN Change Error message-->
                    <f-alert variant="error">
                       {{rootScope.activeCustTab.pinChangeApp?.pinChngError}}
                    </f-alert>
                  </section>                  
                  <div class="btn-controls">
                    <f-button text="PIN Change" title="PIN Change" [disabled]="!rootScope.isLiveCall"
                      *ngIf="rootScope.activeCustTab.pinChangeApp?.step1Active" type="button" (buttonClicked)="pinChangeAttrUpdate()"
                      variant="progressive" class=""></f-button>
                    <f-button text="Try Again" title="Try Again" (buttonClicked)="pinChangeCanlButton()"
                      *ngIf="this.rootScope.activeCustTab.pinChangeApp.retryBtn && this.rootScope.activeCustTab.pinChangeApp.step3Failed && !rootScope.activeCustTab.pinChangeApp?.pinChangeSucess"
                      [disabled]="rootScope.activeCustTab.pinChangeApp?.step3Active" type="button" variant="action" class="hide1">
                    </f-button>
                    <f-button text="Cancel" title="Cancel" (buttonClicked)="pinChangeCanlButton()"
                      *ngIf="(rootScope.activeCustTab.pinChangeApp?.step2Active || rootScope.activeCustTab.pinChangeApp?.step3Active) && !(!this.rootScope.activeCustTab.pinChangeApp.step3Failed && this.rootScope.activeCustTab.pinChangeApp.step3Complete && rootScope.activeCustTab.pinChangeApp?.pinChangeSucess)"
                      [disabled]="rootScope.activeCustTab.pinChangeApp?.step3Active" type="button" variant="action" class="hide1">
                    </f-button>
                  </div>
                </div>
              </mat-expansion-panel>

          <!-- Security Q&As -->
          <mat-expansion-panel (opened)="openAccState(eGainConfig.SQA)" (closed)="closeAccState(eGainConfig.SQA)"
            [expanded]='menuExpansionType(eGainConfig.SQA)' *ngIf="isAuthenticationMethodVisible('SQA')">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <ng-container *ngIf="enableAuthLink('SQA'); else elseBlock3">
                  Security Q&As
                </ng-container>
                <ng-template #elseBlock3>
                  <span class="disabledLink"> Security Q&As (Unavailable)</span>               
                </ng-template>
              </mat-panel-title>
             
            </mat-expansion-panel-header>
           <ng-container *ngIf="enableAuthLink('SQA')">
            <f-alert variant="info" class="status-msg hide">The customer must set up Q&As on Alight Worklife® to use
              this method.</f-alert>
            <f-alert variant="error" class="status-msg hide">Your answers do not match. <a href="#">Try
                again</a></f-alert>
            <f-alert class="error-with-heading alert-info hide" variant="info">
              <!--CCR3-11718 UI Issue fix class added-->
              <p class="alert-top-heading">Customer Data Validated</p>
              <p>The customer must change the PIN to complete the Security Q&A Flow.</p>
            </f-alert>
            <div class="security-form hide1">
              <p>Answer the required security related questions below, then click validate. Answers for these inputs are
                case sensitive.</p>

              <div class="container security-qa">
                <div class="row">
                  <div class="col-md-12">
                    <p class="qa-content">1. What was the last name of your favorite teacher in elementary school?</p>

                    <mat-form-field appearance="fill" class="component-box">
                      <mat-label>Example answer</mat-label>
                      <input matInput id="answer1" value="" title="The text is not case sensitive" />
                    </mat-form-field>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <p class="qa-content">2. What is the name of your oldest nephew?</p>
                    <mat-form-field appearance="fill" class="component-box">
                      <mat-label>Example answer</mat-label>
                      <input matInput id="answer2" value="" title="The text is not case sensitive" />
                    </mat-form-field>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <p class="qa-content">3. In what city were you married?</p>
                    <mat-form-field appearance="fill" class="component-box">
                      <mat-label>Example answer</mat-label>
                      <input matInput id="answer3" value="" title="The text is not case sensitive" />
                    </mat-form-field>
                  </div>
                </div>
                <div class="row footer-btn">
                  <div class="col-md-12">
                    <f-button text="Cancel" title="Cancel" type="button" variant="action"></f-button>
                    <f-button text="Validate" title="Validate" type="submit" variant="progressive" disabled="true">
                    </f-button>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          <div *ngIf="infoWarning()" class="error-wrapper">
            <f-alert variant="info" class="status-msg">{{infoMessage}}</f-alert>
          </div>
          </mat-expansion-panel>
          <!-- One Time Code CCR6-572 -->
          
          <!-- PIN Reset -->
          <mat-expansion-panel (opened)="openAccState(eGainConfig.PINRESET)" (closed)="closeAccState(eGainConfig.PINRESET)"
            [expanded]='menuExpansionType(eGainConfig.PINRESET)' *ngIf="isPeaVisible(eGainConfig.PINRESET)">
            <mat-expansion-panel-header>
          
              <mat-panel-title>
                <ng-container *ngIf="enableAuthLink(eGainConfig.PINRESET); else elseBlock6">
                  PIN Reset
                </ng-container>
                <ng-template #elseBlock6>
                  <span class="disabledLink"> PIN Reset (Unavailable)</span>
                </ng-template>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <app-pin-reset-panel *ngIf="enableAuthLink(eGainConfig.PINRESET)"> </app-pin-reset-panel>
          
            <div *ngIf="infoValidation(eGainConfig.PINRESET)" class="error-wrapper">
              <f-alert variant="info" class="status-msg">{{infoMessage}}</f-alert>
            </div>
                <!----Bad Address Info message-->
                <div class="error-wrapper hide">
                  <f-alert variant="info" class="status-msg">This customer has a Bad Address Indicator and needs to proceed with One-time Code</f-alert>
                </div>
          </mat-expansion-panel>

           <!-- Indicative data -->

           <mat-expansion-panel (opened)="cusAccService.getIndicativeData();openAccState(eGainConfig.IND_DATA)"
           (closed)="closeAccState(eGainConfig.IND_DATA)" *ngIf="isAuthenticationMethodVisible(eGainConfig.IND_DATA)"
           [expanded]='menuExpansionType(eGainConfig.IND_DATA)'>
           <mat-expansion-panel-header>
             <mat-panel-title>
             <ng-container *ngIf="!infoWarning(eGainConfig.IND_DATA); else elseBlock">
               Indicative Data
             </ng-container>
             <ng-template #elseBlock>
               <span class="disabledLink"> Indicative Data (Unavailable)</span>               
             </ng-template>
           </mat-panel-title>
           </mat-expansion-panel-header>
              <!-- CCR3-16779 Grouping of Indicative Data fields -->
           <div class="error-wrapper hide">
             <f-alert variant="info" class="status-msg">Identification options are displayed in groups. Only one option per group is required for successful authentication. Disabled options indicate they are not available for the caller.</f-alert>
           </div>
           <div class="error-wrapper"
             *ngIf="(rootScope.isLiveCall || rootScope.isLiveChat ) && rootScope.activeCustTab.authenticationIndicativeData.validationFailure">
             <f-alert variant="error">{{validationFailureErrorMessage}}</f-alert>
           </div>
           <div *ngIf="infoWarning(eGainConfig.IND_DATA)" class="error-wrapper">
             <f-alert variant="info" class="status-msg">{{infoMessage}}</f-alert>
           </div>
           <div *ngIf="(rootScope.activeCustTab?.activeCall || rootScope.activeCustTab?.activeChat) && showIndicativeDataErr()" class="error-wrapper">
             <f-alert variant="error">{{errorMessage}}
               <span *ngIf="rootScope.activeCustTab.authenticationIndicativeData.indicativeDataAPIFailure">
                 <button (click)="cusAccService.getIndicativeData()" class="btn-alert">Try again</button>
               </span>
             </f-alert>
           </div>
           <p
             *ngIf="rootScope.activeCustTab?.authenticationIndicativeData?.indicativeData && rootScope.activeCustTab?.authenticationIndicativeData?.indicativeData.length > 0&&!infoWarning(eGainConfig.IND_DATA)">
             Enter all information below, then click Validate.
           </p>

           <div class="container validation-method indicative-data" *ngIf="!infoWarning(eGainConfig.IND_DATA)">
             <span
               *ngIf="rootScope.activeCustTab?.authenticationIndicativeData?.indicativeData && rootScope.activeCustTab?.authenticationIndicativeData?.indicativeData.length > 0">
               <form [formGroup]="cusAccService.indicativeDataForm">
                 <span *ngFor="let group of rootScope.activeCustTab?.authenticationIndicativeData?.indicativeData">
                   <!-- Add necessary HTML structure for groups -->

                   <span *ngFor="let subgroup of group.subgroups">
                     <!-- Add necessary HTML structure for subgroups -->

                     <span *ngFor="let section of subgroup.sections">
                       <!-- Add necessary HTML structure for sections -->

                       <span *ngFor="let subgroup of section.sectionsubgroups">
                         <!-- Add necessary HTML structure for sectionsubgroups -->

                         <div class="row" *ngFor="let element of subgroup.elements">
                           <div class="col-md-6">
                            <!--CCR1-13262  Postal address field addition-->
                             <mat-form-field *ngIf="element.title !== 'DOB' && element.title !== postalAddress" appearance="fill" class="component-box">
                               <mat-label>{{element.key}}</mat-label>
                               <input matInput [id]="element.key" [formControlName]="element.key" appAutoCompleteOff />
                             </mat-form-field>
                             <mat-form-field *ngIf="element.title === 'DOB'" appearance="fill" class="component-box">
                               <mat-label>Date of Birth (MM/DD/YYYY)</mat-label>
                               <input matInput [max]="maxDate" [id]="element.key" appAutoCompleteOff
                                 [formControlName]="element.key" [matDatepicker]="picker1" appIndicativeDobFormat/>
                               <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                               <mat-datepicker #picker1></mat-datepicker>
                               <mat-error class="dob_error"><f-icon icon-config='{"iconName": "circle-xmark", "iconType": "solid", "iconSize": "s"}'></f-icon>{{
                                 getIndicativeDataDobErrorMessages(element)
                                 }}</mat-error>
                             </mat-form-field>
                             <!--CCR1-13262 Indicative Data Postal Address-->
                              <div *ngIf="element.title === postalAddress" class="postal-address">
                                <div class="address-section">
                                  <span class="address-label">Postal Address</span>
                                  <ng-container
                                    *ngFor="let line of (cusAccService?.indicativeDataForm?.get(element.key)?.value || '').split('\n')">
                                    <span class="address-line">{{ line?.trim() }}</span>
                                  </ng-container>
                                </div>
                              </div>
                           </div>
                           <div *ngIf="element.title === 'FULLNAME'" class="col-md-6">
                             <mat-checkbox [formControlName]="'additionalCheckboxKey'" color="primary" class="verify-checkbox">
                               The customer’s name is verified.</mat-checkbox>
                           </div>
                          <!--CCR1-13262 Indicative Data Address Confirmation-->
                           <div *ngIf="element.title === postalAddress" class="col-md-6">
                             <mat-checkbox [formControlName]="'additionalAddressCheckboxKey'" color="primary"  class="verify-checkbox">
                               The customer’s address is verified.</mat-checkbox>
                           </div>
                           <div *ngIf="cusAccService.checkIVRConfirmation(section)" class="col-md-6">
                             <span class="data-verified "><f-icon icon-config='{"iconName": "circle-check", "iconType": "light", "iconSize": "s"}'></f-icon> Confirmed via
                               IVR</span>
                           </div>
                         </div>

                       </span>
                     </span>
                   </span>
                 </span>

                 <div class="row footer-btn">
                   <div class="col-md-12">
                     <f-button text="Cancel" title="Cancel"
                       [disabled]="rootScope.activeCustTab.authenticationIndicativeData.indicativeDataValueMiss"
                       (buttonClicked)="onCancelIndicativeData()" type="button" variant="action"></f-button>
                     <f-button text="Validate" title="Validate" [disabled]="indicativeValidation()" (buttonClicked)="onSubmit()"
                       type="button" variant="progressive">
                     </f-button>
                   </div>
                 </div>
               </form>
             </span>

             <!-- CCR3-16779 Grouping of Indicative Data fields -->
<!-- <form class="hide group-validation-form">
  <div class="row heading-row">
    <p><strong>Name Validation</strong></p>
  </div>
  
  <div class="row row-bottom-margin">
    <div class="custom-text-width">
      <mat-form-field appearance="fill" class="component-box">
        <mat-label>First and Last Name</mat-label>
        <input matInput autoCompleteOff />
      </mat-form-field>
    </div>
    <div class="verify-col">
      <mat-checkbox class="verify-checkbox" color="primary">
        The customer’s name is verified.</mat-checkbox>
    </div>

    <div  class="col-md-6 hide">
                             <span class="data-verified "><f-icon icon-config='{"iconName": "circle-check", "iconType": "light", "iconSize": "s"}'></f-icon> Confirmed via
                               IVR</span>
                           </div>
  </div>
   <div class="row heading-row">
  <p><strong>Date Validation</strong></p>
  </div>
  <mat-radio-group color="primary" class="account-selection custom-radio-selection row-bottom-margin" disableRipple
    aria-label="Select an option" [(ngModel)]="selectedDateValidation">
    <div class="row">

      <div>
        <mat-radio-button class="custom-radio-width" value="dob">
          <mat-form-field appearance="fill" class="component-box">
            <mat-label>Date of Birth (MM/DD/YYYY)</mat-label>
            <input matInput [max]="maxDate" id="dob" autoCompleteOff formControlName="dob" [matDatepicker]="picker1" appIndicativeDobFormat/>
            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
            <mat-datepicker #picker1></mat-datepicker>

          </mat-form-field>
        </mat-radio-button>

      </div>
      <div>
                    <span class="data-verified "><f-icon
                            icon-config='{"iconName": "circle-check", "iconType": "light", "iconSize": "s"}'></f-icon> Confirmed via
                        IVR</span>
                </div>
    </div>
    <div class="row row-top-margin row-bottom-margin">
      <div>

        <mat-radio-button class="custom-radio-width " value="hiredate">
          <mat-form-field appearance="fill" class="component-box date-field">
            <mat-label>Hire Date</mat-label>
            <input matInput id="hiredate" value="" />
          </mat-form-field>
        </mat-radio-button>

      </div>
    </div>
    <div>
        <mat-radio-button class="custom-radio-width" value="dot">
          <mat-form-field appearance="fill" class="component-box">
            <mat-label>Date of Termination (MM/DD/YYYY)</mat-label>
            <input matInput [max]="maxDate" id="dot" autoCompleteOff formControlName="dot" [matDatepicker]="picker2" />
            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
            <mat-datepicker #picker2></mat-datepicker>

          </mat-form-field>
        </mat-radio-button>

      </div>
  </mat-radio-group>

  <p><strong>Identifier Validation</strong></p>
  <mat-radio-group color="primary" class="account-selection custom-radio-selection" disableRipple
    aria-label="Select an option" [(ngModel)]="selectedIdentifierValidation">
    <div class="row">

      <div>
        <mat-radio-button class="custom-radio-width" value="nationalId">
          <mat-form-field appearance="fill" class="component-box date-field">
            <mat-label>Last 4 of National ID</mat-label>
            <input matInput id="nationalId" value="" />
          </mat-form-field>
        </mat-radio-button>

      </div>
    </div>
    <div class="row row-top-margin row-bottom-margin">
      <div>

        <mat-radio-button class="custom-radio-width" value="eeid">
          <mat-form-field appearance="fill" class="component-box date-field">
            <mat-label>Employee ID (EEID)</mat-label>
            <input matInput id="eeid" value="" />
          </mat-form-field>
        </mat-radio-button>

      </div>
    </div>
    <div class="row row-top-margin row-bottom-margin">
      <div>

        <mat-radio-button class="custom-radio-width" value="last4eeid">
          <mat-form-field appearance="fill" class="component-box date-field">
            <mat-label>Last 4 of EEID</mat-label>
            <input matInput id="last4eeid" value="" />
          </mat-form-field>
        </mat-radio-button>

      </div>
    </div>
  </mat-radio-group>

  <p><strong>Location Validation</strong></p>
  <mat-radio-group color="primary" class="account-selection custom-radio-selection row-bottom-margin" disableRipple
    aria-label="Select an option" [(ngModel)]="selectedIdentifierValidation">
    <div class="row">

      <div>
        <mat-radio-button class="custom-radio-width" value="postalCode">
          <mat-form-field appearance="fill" class="component-box date-field">
            <mat-label>Postal Code</mat-label>
            <input matInput id="postalCode" value="" />
          </mat-form-field>
        </mat-radio-button>

      </div>
    </div>
    <div class="row row-bottom-margin postal-address-validation">
      <mat-radio-button class="custom-radiotextarea-width" value="postalAddress">
        <div class="">
          <f-textarea [value]="'149 Sulphur Springs Road\nUpper Darby\nPA 19082'" [disabled]="true">
          </f-textarea>
        </div>
      </mat-radio-button>
      <div class="verify-col" >
        <mat-checkbox class="verify-checkbox" color="primary">
          The customer’s address is verified.</mat-checkbox>
      </div>

      <div  class="col-md-6 hide">
                             <span class="data-verified "><f-icon icon-config='{"iconName": "circle-check", "iconType": "light", "iconSize": "s"}'></f-icon> Confirmed via
                               IVR</span>
                           </div>
    </div>
  </mat-radio-group>

  <div class="row footer-btn">
    <div class="col-md-12">
      <f-button text="Cancel" title="Cancel" [disabled]="true" type="button" variant="action"></f-button>
      <f-button text="Validate" title="Validate" [disabled]="true" type="button" variant="progressive">
      </f-button>
    </div>
  </div>
</form> -->

           </div>
         </mat-expansion-panel>

          <!-- Approved Exceptions -->
          <mat-expansion-panel (opened)="openAccState(eGainConfig.APE)" (closed)="closeAccState(eGainConfig.APE)"
            [expanded]='menuExpansionType(eGainConfig.APE)' *ngIf="isAuthenticationMethodVisible('APE')">
            <mat-expansion-panel-header>
              <mat-panel-title> Approved Exceptions </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="exceptions-main">
              <button class="link" [tabindex]="rootScope.activeCustTab.authenticateStatus === fullySecured ? -1 : 0"
                [ngClass]="{'disabledLink': rootScope.activeCustTab.authenticateStatus === fullySecured}"
                (click)="goToApprovedExceptionPage()">Go to the Approved
                Exceptions page.</button>
            </div>
          </mat-expansion-panel>

          <!-- Voluntary Account Lock -->
          <mat-expansion-panel (opened)="openAccState(eGainConfig.VAL)" (closed)="closeAccState(eGainConfig.VAL)" 
          *ngIf="isAuthenticationMethodVisible('VAL')"   [expanded]='menuExpansionType(eGainConfig.VAL)' >
            <mat-expansion-panel-header>
              <mat-panel-title>
                <ng-container *ngIf="valState(); else elseBlock8">
                  <span > Voluntary Account Lock App </span>
                </ng-container>
                <ng-template #elseBlock8 >
                  <span class="disabledLink"> Voluntary Account Lock App (Unavailable)</span>                    
                </ng-template>
              </mat-panel-title> 
            </mat-expansion-panel-header>
            <div class="vol-lock-container">

              <div class="error-wrapper" *ngIf="!valState()"> 
                <f-alert variant="info"> {{ valMsg }}</f-alert>
              </div>

              <app-voluntary-account-lock *ngIf="valState()"></app-voluntary-account-lock>

              <!-- Steps container -->
           
            </div>
          </mat-expansion-panel>
            <!-- Alight Identity Verification Service (AIDV) -->
        
          <mat-expansion-panel *ngIf="rootScope.activeCustTab.clearIdentityData?.isClearIdentityEnabled
          && isPeaVisible(eGainConfig.AIDV)" (opened)="openAccState(eGainConfig.AIDV)" 
          (closed)="closeAccState(eGainConfig.AIDV)"   [expanded]='menuExpansionType(eGainConfig.AIDV)'>
            <mat-expansion-panel-header>
          
              <mat-panel-title>
                <ng-container *ngIf="clearIdentityService.clearInfoMessage() ; else elseBlock9">
                  Alight Identity Verification Service (AIDV)
                </ng-container>
                 <ng-template #elseBlock9 >
                  <span class="disabledLink"> Alight Identity Verification Service (AIDV) (Unavailable)</span>
                </ng-template> 
              </mat-panel-title>
            </mat-expansion-panel-header>
             <div *ngIf="clearIdentityService.clearMsg" class="error-wrapper">
            <f-alert variant="info" class="status-msg">{{clearIdentityService.clearMsg}}</f-alert>
          </div>
            <app-clear-verification *ngIf="!clearIdentityService.clearMsg"> </app-clear-verification>
          </mat-expansion-panel>

         
        </mat-accordion>
      </div>

      <div class="col-md-12 col-lg-6 authentication-right authentication-main">
       <!--Refresh icon on Egain Panel, to be shown on condition basis-->
        <div class="refresh-egain hide1" *ngIf="rootScope.activeCustTab.authenticationEgainContent?.authenticationType">
          <button mat-button color="primary" title="Refresh" class="btn-refresh"  (click)="eGainUpdate(rootScope.activeCustTab.authenticationEgainContent.authenticationType)">
            <f-icon icon-config='{"iconName": "arrows-rotate", "iconType": "solid", "iconSize": "s"}'></f-icon>
          </button>
         </div>
        <div class="authentication-content">
          <section *ngIf="rootScope.activeCustTab?.authenticationEgainContent?.authEgainError">
            <f-alert variant="error" class="status-msg hide1">
              {{rootScope.activeCustTab?.authenticationEgainContent?.authEgainError}}</f-alert>
          </section>
          <h1>{{rootScope.activeCustTab?.authenticationEgainContent?.authenticationHtml?.name}}</h1>
          <div
            [innerHTML]="rootScope.activeCustTab?.authenticationEgainContent?.authenticationHtml?.content| safe: 'html'">
          </div>
                   <!-- Functional Loader to be added when in use -->
        <app-loader *ngIf="showEgainLoader" [loaderType]="loaderType"></app-loader>
        </div>
        <!-- Pin reset conetent as per CCR3-2382  -->

      </div>
    </div>
  </div>
</f-data-card>